export default {
  formContainer: {
    padding: 40,
  },
  buttonsBox: {
    paddingTop: 20,
  },
  buttonSave: {
    marginLeft: 20,
    width: 125,
  },
  buttonCancel: {
    width: 125,
  },
}
